<template>
  <div class="home-block">
    <home-block-title
      title="校园新闻"
      linkText="追寻龙旅足迹 讲好龙旅故事"
      :link="{ name: '学院介绍', query: { tab: '3' } }"
    />

    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="left" @click="showInfo(item)">
          <img
            v-if="!item.iconUrl && item.isHot == '0'"
            src="../../assets/images/hot.png"
          />
          <img
            v-if="!item.iconUrl && item.isNew == '0'"
            src="../../assets/images/new.png"
          />
          <div class="text">{{ item.listTitle }}</div>
        </div>
        <div class="right">
          {{ formatDate(item.infoTime, "Y-M-D") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import homeBlockTitle from "./home-block-title.vue"
  import { getNewsList } from "@/api/home"
  export default {
    components: { homeBlockTitle },
    data() {
      return {
        list: []
      }
    },
    created() {},
    mounted() {
      this.load()
    },
    methods: {
      load() {
        this.request()
      },
      request() {
        const sendData = {
          menuId: 0,
          pageNum: 1,
          pageSize: 10
        }
        getNewsList(sendData).then((res) => {
          const list = res.data.rows
          this.list = list
        })
      },
      formatDate(date, format) {
        var d = new Date(date)
        var map = {
          Y: d.getFullYear(),
          M: d.getMonth() + 1,
          D: d.getDate(),
          hh: d.getHours(),
          mm: d.getMinutes(),
          ss: d.getSeconds()
        }

        // 从左边补齐二位
        for (var f2 in map) {
          map[f2] = map[f2].toString().padStart(2, "0")
        }

        for (var f1 in map) {
          format = format.replace(f1, map[f1])
        }
        return format
      },

      showInfo(item) {
        const apiUrl = `/web/consult/setting/get/one?id=${item.id}`

        this.$router.push({
          path: "/commonShow",
          query: {
            // 使用URL中的 query的值显示数据
            f: 1,
            // 数据源
            apiUrl: apiUrl,

            // 面包屑 第二级菜单
            localActiveParentMenu: "校园新闻",

            // 面包屑 第三级菜单
            localActiveMenu: "龙旅新闻"
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss"></style>
